// @ts-ignore
import {Table} from "react-bootstrap";
import React, {useState, useRef} from "react";
import SummaryTableRow from "./SummaryTableRow";
import TableIcon from "./TableIcon";
// @ts-ignore
// import * as d3 from "d3";


function SummaryTable({data, headers}) {
    const [sort, setSort] = useState({ keyToSort: "make", direction: "asc" });

    // console.log(headers);

    function handleHeaderClick(header) {
        // console.log(header);
        setSort({
            keyToSort: header.key,
            direction:
                (header.key === sort.keyToSort)
                    ? sort.direction === "asc"
                        ? "desc"
                        : "asc"
                    : "desc",
        });
        // console.log(sort);
    }

    function getSortedArray(arrayToSort) {
        if(sort.direction === "asc") {
            return arrayToSort.sort((a, b) => (a[sort.keyToSort] > b[sort.keyToSort] ? 1 : -1));
        }
        return arrayToSort.sort((a, b) => (a[sort.keyToSort] > b[sort.keyToSort] ? -1 : 1));
    }



    // @ts-ignore
    return (
        <>
            <Table striped borderless size="sm" >
                <thead>
                <tr>
                    {headers.map((header, index) => {
                        return (
                            <th key={index} onClick={() => handleHeaderClick(header)}>
                                <div className={`${(header.key === sort.keyToSort) ? "text-body" : " "}`}>
                                    {header.label}

                                    {header.key === sort.keyToSort && (
                                        <TableIcon
                                            direction={
                                                sort.keyToSort === header.key ? sort.direction : "asc"
                                            }
                                        ></TableIcon>
                                    )}
                                </div>
                            </th>
                        );
                    })}


                </tr>
                </thead>
                <tbody className="text-nowrap">
                {getSortedArray(data).map((row, index) => (
                    <SummaryTableRow rowData={row}

                                     key={index}
                    />
                ))}
                </tbody>
            </Table>
        </>


    )
        ;
}


export default SummaryTable;
